module.exports = __webpack_public_path__ + "img/close-modal-icon.e180a7dd.svg";